// Typed errors for ExpoAmsClient. The client maps backend error-shape
// contracts (401/403/400/5xx) to these classes; callers can narrow with
// instanceof for UX decisions.

export class UnauthenticatedError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'UnauthenticatedError';
  }
}

export class InsufficientPrivilegeError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'InsufficientPrivilegeError';
  }
}

export class InvalidRequestError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'InvalidRequestError';
  }
}

export class InternalError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'InternalError';
  }
}

// Plan 10: structured 400 for expoamsUpdateSheetConfig when per-sheet
// validation rejects one or more entries.
export interface SheetValidationResult {
  sheetId: string;
  ok: boolean;
  reason?: string | undefined;
  displayName?: string | undefined;
}

export class InvalidSheetsError extends InvalidRequestError {
  readonly results: SheetValidationResult[];
  constructor(msg: string, results: SheetValidationResult[]) {
    super(msg);
    this.name = 'InvalidSheetsError';
    this.results = results;
  }
}
